<template>
  <transition name="slide-up">
    <div v-if="showBanner" class="cookie-banner">
      <div class="cookie-banner-content">
        <div class="cookie-text">
          Для обеспечения работы сайта мы используем технические файлы cookie.
          С вашего разрешения мы также можем использовать аналитические и маркетинговые сервисы
          (ВКонтакте, Mail.ru, Яндекс.Метрика), чтобы анализировать взаимодействие с сайтом
          и показывать более релевантную рекламу.
        </div>
        <div class="cookie-buttons">
          <button class="cookie-button accept-button" @click="acceptCookies">
            Принять аналитические cookies
          </button>
          <button class="cookie-button decline-button" @click="declineCookies">
            Отказаться
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { analyticsConsent } from '@/services/analyticsConsent'

export default {
  name: 'CookieBanner',
  data() {
    return {
      showBanner: false,
    }
  },
  mounted() {
    this.checkConsent()
  },
  methods: {
    checkConsent() {
      if (!analyticsConsent.hasDecision()) {
        setTimeout(() => {
          this.showBanner = true
        }, 1000)
      }
    },
    acceptCookies() {
      analyticsConsent.accept()
      this.showBanner = false
      this.emitter.emit('analytics-accepted')
    },
    declineCookies() {
      analyticsConsent.decline()
      this.showBanner = false
    },
  },
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(43, 45, 115, 0.95);
  color: #ffffff;
  padding: 1rem;
  z-index: 9999;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  border-top: 2px solid #E32289;
}

.cookie-banner-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  gap: 1rem;
}

.cookie-text {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.775rem;
  line-height: 1.25rem;
  text-align: center;
  flex: 1;
}

.cookie-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}

.cookie-button {
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  border-radius: 1rem;
}

.accept-button {
  background: #E32289;
  border: 0.15rem solid #E32289;
  color: #ffffff;
}

.accept-button:hover {
  background: #c91d77;
  border-color: #c91d77;
  transform: translateY(-2px);
}

.accept-button:active {
  transform: translateY(0);
}

.decline-button {
  background: transparent;
  border: 0.15rem solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
}

.decline-button:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.7);
  transform: translateY(-2px);
}

.decline-button:active {
  transform: translateY(0);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-enter-to,
.slide-up-leave-from {
  transform: translateY(0);
  opacity: 1;
}

@media (min-width: 768px) {
  .cookie-banner-content {
    flex-direction: row;
    gap: 2rem;
  }

  .cookie-text {
    text-align: left;
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .cookie-buttons {
    flex-direction: row;
  }
}

@media (min-width: 992px) {
  .cookie-banner {
    padding: 1rem 2rem;
  }
}
</style>
